// extracted by mini-css-extract-plugin
export default {"dataSelect":"DataSelect_dataSelect__63IcB","error":"DataSelect_error__WzfNe"};